import type { CSSProperties } from 'react'
import type { MediaAsset } from '../types'
import { avifSrcSet, preferredVariant, webpSrcSet } from '../lib/media'

interface ResponsivePictureProps {
  asset: MediaAsset
  className?: string
  sizes?: string
  loading?: 'lazy' | 'eager'
  fetchPriority?: 'high' | 'low' | 'auto'
  style?: CSSProperties
}

export function ResponsivePicture({
  asset,
  className,
  sizes = '(max-width: 720px) 92vw, 70vw',
  loading = 'lazy',
  fetchPriority = 'auto',
  style
}: ResponsivePictureProps) {
  const fallback = preferredVariant(asset)
  return (
    <picture className={className} style={style}>
      <source type="image/avif" srcSet={avifSrcSet(asset)} sizes={sizes} />
      <source type="image/webp" srcSet={webpSrcSet(asset)} sizes={sizes} />
      <img
        src={fallback.webp}
        width={asset.width}
        height={asset.height}
        alt={asset.alt}
        loading={loading}
        fetchPriority={fetchPriority}
        decoding={loading === 'eager' ? 'sync' : 'async'}
        style={{ objectPosition: `${asset.focalPoint.x * 100}% ${asset.focalPoint.y * 100}%` }}
      />
    </picture>
  )
}
